
import React from 'react';
import AnimatedCard from '@/components/ui/AnimatedCard';
import { StatCardProps } from './types';
import StatCardContent from './StatCardContent';
import { Button } from '@/components/ui/button';
import { EyeOff } from 'lucide-react';
import { useStatsCardData } from '../useStatsCardData';

const StatsCard: React.FC<StatCardProps> = ({
  id,
  title,
  value,
  change,
  isIncreasing,
  icon,
  bgClass,
  delay,
  isEditMode,
}) => {
  const { toggleCardVisibility } = useStatsCardData();

  const handleHideCard = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggleCardVisibility(id, false);
  };

  return (
    <div className="relative">
      {isEditMode && (
        <Button 
          variant="ghost" 
          size="sm" 
          className="absolute right-2 top-2 z-10 h-8 w-8 p-0 rounded-full bg-white/80 dark:bg-gray-800/80 hover:bg-white dark:hover:bg-gray-800 shadow-sm"
          onClick={handleHideCard}
        >
          <EyeOff className="h-4 w-4 text-gray-500" />
        </Button>
      )}
      <AnimatedCard
        animation="fade-up"
        delay={delay}
        className="border border-gray-200 dark:border-gray-700 shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 bg-white dark:bg-gray-800 backdrop-blur-sm"
      >
        <StatCardContent
          title={title}
          value={value}
          change={change || '0%'}
          isPositiveChange={isIncreasing !== null ? isIncreasing : false}
          icon={icon}
          iconBgClass={bgClass}
        />
      </AnimatedCard>
    </div>
  );
};

export default StatsCard;
